/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component } from 'react' // eslint-disable-line
import { Layout, Menu, Dropdown, Icon } from 'antd'
import SystemConfig from '../../config/loader'
import SessionService from '../../core/session'

import LogoAICloud from '../../assets/logo_ai_cloud.png'

const { Header } = Layout

const sessionService = SessionService.Instance()

const headerStyles = {
  header: css`
    position: fixed;
    width: 100%;
    height: 60px;
    top: 0;
    right: 0;
    z-index: 10;
    background: #fff;
    padding: 0;
    margin-left: 200px;
  `,
  'header-nav': css`
    position: relative;
    height: 60px;
    line-height: 60px;
    background: #fff;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
    width: 100%;

    display: inline-flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  `,
  'nav-menu': css`
    position: relative;
    display: inline-flex;
    justify-content: flex-start;
  `,
  'nav-setting': css`
    position: relative;
    display: inline-flex;
    height: 60px;
    line-height: 60px;
    padding: 0 20px;
    cursor: pointer;

    @media (max-width: 468px) {
      .nav-name {
        display: none;
      }
    }
  `,
}

const logoStyles = {
  'side-logo': css`
    width: 200px;
    height: 60px;
  `,
  'logo-link': css`
    display: inline-flex;
    padding: 10px 16px;
    width: 100%;
    height: 100%;
    background: #343434;
  `,
  'logo-image': css`
    width: 100%;
    height: 100%;
  `,
}

const serverConfig = SystemConfig.loadServerConfig()

const buildMenu = (handleQuit: any) => {
  return (
    <Menu>
      <Menu.Item key="0">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`//${serverConfig.host}`}
        >
          官方网站
        </a>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="2">
        <a href="#" onClick={handleQuit}>退出</a>
      </Menu.Item>
    </Menu>
  )
}

export default () => {
  const menu = buildMenu(() => {})
  const email = sessionService.email
  return (
    <Header css={headerStyles.header}>
      <div className="header-nav" css={headerStyles['header-nav']}>
        <div className="nav-menu" css={headerStyles['nav-menu']}>
          <div className="logo" css={logoStyles['side-logo']}>
            <a css={logoStyles['logo-link']} href="/">
              <img
                src={LogoAICloud}
                css={logoStyles['logo-image']}
                alt="AI-Cloud"
              />
            </a>
          </div>
        </div>
        <div className="nav-setting" css={headerStyles['nav-setting']}>
          <div className="nav-status-inner">
            <div className="status-bar">
              <Dropdown overlay={menu}>
                <span>
                  <span className="nav-name">{email}</span> <Icon type="down" />
                </span>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    </Header>
  )
}
